import type { partnerApplicationMachine } from '~domains/partner-application/entities/application';

import type { SnapshotFrom } from 'xstate';

import {
  PARTNER_APPLICATION_NAV_SECTIONS,
  PARTNER_APPLICATION_NAV_STEPS,
  PartnerApplicationNavSectionId,
  PartnerApplicationNavStepId,
} from './partner-application-nav-step';

type PartnerApplicationState = SnapshotFrom<typeof partnerApplicationMachine>;

const NAV_STEP_IDS: ReadonlySet<string> = new Set(
  Object.values(PARTNER_APPLICATION_NAV_STEPS)
);
const NAV_SECTION_IDS: ReadonlySet<string> = new Set(
  Object.values(PARTNER_APPLICATION_NAV_SECTIONS)
);

const isNavStepId = (value: string): value is PartnerApplicationNavStepId =>
  NAV_STEP_IDS.has(value);

const isNavSectionId = (
  value: string
): value is PartnerApplicationNavSectionId => NAV_SECTION_IDS.has(value);

export const getActiveBusinessNavStepId = (
  state: PartnerApplicationState
): PartnerApplicationNavStepId | undefined => {
  const { value } = state;

  if (
    typeof value !== 'object' ||
    value === null ||
    !('businessBlock' in value)
  ) {
    return undefined;
  }

  const businessState = value.businessBlock;

  return typeof businessState === 'string' && isNavStepId(businessState)
    ? businessState
    : undefined;
};

export const getActivePartnerNavSectionId = (
  state: PartnerApplicationState
): PartnerApplicationNavSectionId | undefined => {
  const { value } = state;
  const topLevelState =
    typeof value === 'string' ? value : Object.keys(value)[0];

  return isNavSectionId(topLevelState) ? topLevelState : undefined;
};
